import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import { FormProvider, useForm } from 'react-hook-form';
import React, { useEffect, useState } from 'react';

import { FormMap } from '@uml/uml-components';
import { getCookie } from '../utilities/cookie';
import { postRequest } from '../services/procedures';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  buttonRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -15,
    marginLeft: -15,
  },
  title: {
    fontSize: '2.4rem',
  },
}));

const ProcedureForm = ({ setStep, step, procedure, procedureId }) => {
  const methods = useForm();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    let application_type = step === 'notes' ? 'Uwaga' : 'Wniosek';
    const tempData = {
      form_content: data,
      user_mail: user_email,
      procedure: procedureId,
      application_type: application_type,
      external_user_uid: getCookie('mu_id'),
      procedure_application_form:
        application_type === 'Uwaga'
          ? procedure.note_form
          : procedure.application_form,
    };

    const files = Object.fromEntries(
        Object.entries(data).filter(([key]) => key.includes('files_')),
      );
      tempData.form_content.files = Object.values(files).flat();
      const keysToRemove = Object.keys(data).filter(
        (key) => key.includes('files_') || key.includes('file_uploader_'),
      );
      keysToRemove.forEach((item) => delete tempData.form_content[item]);

    try {
      await postRequest(tempData);
      window.location.replace(`/profil/projekty/?service=pp&infoModal=true`);
    } catch (error) {
      enqueueSnackbar('Nie udało się zapisać danych', {
        variant: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!getCookie('mu_id')) {
      window.location.replace(`${window.location.origin}/login/`);
    }
  }, []);

  const onError = () => {
    enqueueSnackbar('Niektóre pola wymagają poprawy/uzupełnienia', {
      variant: 'error',
    });
  };

  return (
    <div>
      <h1 className={classes.title}>
        Formularz zgłoszenia {step === 'notes' ? 'uwag ' : 'wniosku '}
        {procedure.name}
      </h1>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit, onError)}>
          <FormMap
            elements={
              (procedure?.procedure_pattern === 'Uwagi' ||
                procedure?.procedure_pattern === 'Uwagi i wnioski') &&
              step === 'notes'
                ? procedure?.note_form_preview?.content
                : procedure?.application_form_preview?.content
            }
            formData={false}
            availableMapLayers={availableLayers}
            currentService='pp'
          />
          <div className={classes.buttonRow}>
            <Button
              color='primary'
              variant='outlined'
              onClick={() => setStep('menu')}
              type='button'
              disabled={loading}
            >
              Anuluj
            </Button>
            <div className={classes.wrapper}>
              <Button
                color='primary'
                disabled={loading}
                variant='contained'
                type='submit'
              >
                Kontynuuj
              </Button>
              {loading && (
                <CircularProgress
                  size={30}
                  className={classes.buttonProgress}
                />
              )}
            </div>
            <div />
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default ProcedureForm;
